import { render, staticRenderFns } from "./KnowledgeBaseForm.vue?vue&type=template&id=21497989"
import script from "./KnowledgeBaseForm.vue?vue&type=script&lang=js"
export * from "./KnowledgeBaseForm.vue?vue&type=script&lang=js"
import style0 from "./KnowledgeBaseForm.vue?vue&type=style&index=0&id=21497989&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports